function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M246.7 148.8L180.1 82l18.4-18.2L134.6 0 92.1 42.5l-85 28.4 113.3 120.5 35.4-85.3 4-4 48.3 46.8-87.3 106.3H92.1v28.3h127.6v-28.3h-62l89-106.4zM131.9 89.9l-2.2 5.2-18.6 44.9-53-56.3 43-14.3 6.3-2.1 4.7-4.7 22.5-22.5 23.6 23.6-22.3 22.2-4 4z"
})));